import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      setDone(true);
      toast.success("Message sent. We'll get back to you.");
    } catch {
      toast.error("Send failed — try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <PageHeader
        eyebrow="Contact"
        title="Talk to the crew"
        description="Sizing, orders, collabs, press — whatever it is, we read everything."
      />
      <div className="grid gap-10 px-5 py-12 sm:px-10 lg:grid-cols-[1.4fr_1fr] lg:px-16">
        <Reveal>
          {done ? (
            <div className="flex items-center gap-4 border border-signal/50 bg-signal/10 p-8" data-testid="contact-success">
              <Check className="h-5 w-5 text-signal" />
              <div>
                <p className="font-display text-lg font-bold uppercase">Message received</p>
                <p className="mt-1 text-sm text-muted-foreground">
                  We usually reply within 1–2 business days.
                </p>
              </div>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="contact-form" className="border border-border p-8">
              <input
                value={form.name}
                onChange={set("name")}
                required
                placeholder="NAME"
                data-testid="contact-name-input"
                className="w-full border-b border-border bg-transparent py-3.5 font-mono text-xs uppercase tracking-[0.2em] placeholder:text-muted-foreground focus:border-signal focus:outline-none"
              />
              <input
                type="email"
                value={form.email}
                onChange={set("email")}
                required
                placeholder="EMAIL ADDRESS"
                data-testid="contact-email-input"
                className="mt-5 w-full border-b border-border bg-transparent py-3.5 font-mono text-xs uppercase tracking-[0.2em] placeholder:text-muted-foreground focus:border-signal focus:outline-none"
              />
              <textarea
                value={form.message}
                onChange={set("message")}
                required
                rows={5}
                placeholder="MESSAGE"
                data-testid="contact-message-input"
                className="mt-5 w-full resize-none border-b border-border bg-transparent py-3.5 font-mono text-xs uppercase tracking-[0.2em] placeholder:text-muted-foreground focus:border-signal focus:outline-none"
              />
              <button
                type="submit"
                disabled={busy}
                data-testid="contact-submit-button"
                className="mt-8 flex items-center gap-2 bg-signal px-8 py-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors hover:bg-signal/90 disabled:opacity-40"
              >
                Send message <ArrowRight className="h-4 w-4" />
              </button>
            </form>
          )}
        </Reveal>
        <Reveal delay={0.1}>
          <div className="space-y-6 border border-border p-8 font-mono text-xs uppercase tracking-[0.18em]">
            <div>
              <p className="text-muted-foreground">Support</p>
              <p className="mt-2 text-foreground">support@trailnone.com</p>
            </div>
            <div>
              <p className="text-muted-foreground">Press & collabs</p>
              <p className="mt-2 text-foreground">studio@trailnone.com</p>
            </div>
            <div>
              <p className="text-muted-foreground">Response time</p>
              <p className="mt-2 text-foreground">1–2 business days</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
